import { cva } from "class-variance-authority";

export const backendControlBaseClass =
  "w-full rounded-[9px] border border-[var(--c-border)] bg-[var(--c-card)] font-[var(--font-backend-sans)] text-[var(--c-text)] shadow-none outline-none transition-colors placeholder:text-[var(--c-muted)] focus:border-[var(--c-border-strong)] focus:ring-0 focus:outline-none disabled:cursor-not-allowed disabled:opacity-50 read-only:cursor-default read-only:bg-[var(--c-surface-sunken)]";

export const backendInputClass = [
  backendControlBaseClass,
  "h-10 px-3 text-[16px] lg:text-sm",
  "placeholder:text-sm placeholder:font-normal",
].join(" ");

export const backendTextareaClass = [
  backendControlBaseClass,
  "min-h-[112px] resize-y px-3 py-2.5 text-[16px] lg:text-sm",
  "placeholder:text-sm placeholder:font-normal",
].join(" ");

export const backendSelectTriggerClass = [
  backendControlBaseClass,
  "h-10 !cursor-pointer justify-between px-3 py-2 text-[16px] lg:text-sm disabled:!cursor-not-allowed",
  "*:data-[slot=select-value]:line-clamp-1",
].join(" ");

export const backendSelectContentClass =
  "z-[120] overflow-hidden rounded-[14px] border-0 bg-[var(--c-card)] p-0 font-[var(--font-backend-sans)] text-[var(--c-text)] shadow-[0_16px_44px_rgba(80,60,20,0.18)] [&_[data-slot=select-viewport]]:p-0";

export const backendSelectItemClass =
  "cursor-pointer rounded-none border-t border-t-[var(--c-border-soft-2)] px-4 py-[11px] text-sm outline-none hover:bg-[var(--c-surface)] focus:bg-[var(--c-surface)] focus:text-[var(--c-ink)] data-[highlighted]:bg-[var(--c-surface)] data-[highlighted]:text-[var(--c-ink)] data-[state=checked]:bg-[var(--c-surface)] data-[state=checked]:font-semibold [&_svg]:!text-[var(--c-accent)]";

export const backendButtonVariants = cva(
  "inline-flex cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-[10px] font-[var(--font-backend-sans)] text-sm font-semibold transition-colors focus-visible:ring-2 focus-visible:ring-[var(--c-accent)] focus-visible:ring-offset-2 focus-visible:outline-none disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0",
  {
    variants: {
      variant: {
        default:
          "border border-[var(--c-ink)] bg-[var(--c-ink)] text-white hover:bg-[var(--c-text-soft)]",
        secondary:
          "border border-[var(--c-border)] bg-[var(--c-card)] text-[var(--c-ink)] hover:bg-[var(--c-surface)]",
        outline:
          "border border-[var(--c-border)] bg-[var(--c-card)] text-[var(--c-ink)] hover:bg-[var(--c-surface)]",
        ghost:
          "border border-transparent bg-transparent text-[var(--c-muted)] hover:bg-[var(--c-surface)] hover:text-[var(--c-ink)]",
        destructive:
          "border border-[var(--color-destructive)] bg-[var(--color-destructive)] text-white hover:brightness-95",
        link: "h-auto rounded-none border-0 bg-transparent p-0 font-semibold text-[var(--c-accent)] underline-offset-4 hover:underline",
      },
      size: {
        xs: "h-7 px-2.5 text-xs",
        sm: "h-8 px-3 text-xs",
        md: "h-10 px-4",
        default: "h-10 px-4",
        lg: "h-11 px-5",
        icon: "size-9 p-0",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "default",
    },
  }
);

export const backendTabsListClass =
  "inline-flex h-auto w-fit items-center justify-center rounded-[11px] border border-[var(--c-border)] bg-[var(--c-surface)] p-1";

export const backendTabsTriggerClass =
  "inline-flex h-8 flex-1 cursor-pointer items-center justify-center gap-1.5 rounded-[8px] border border-transparent px-3 text-xs font-semibold whitespace-nowrap text-[var(--c-muted)] transition-colors outline-none data-[state=inactive]:hover:!text-[var(--c-ink)] focus-visible:ring-2 focus-visible:ring-[var(--c-accent)] disabled:pointer-events-none disabled:opacity-50 data-[state=active]:!border-[var(--c-ink)] data-[state=active]:!bg-[var(--c-ink)] data-[state=active]:!text-white data-[state=active]:shadow-none data-[state=active]:hover:!bg-[var(--c-ink)] data-[state=active]:hover:!text-white dark:data-[state=active]:!border-[var(--c-ink)] dark:data-[state=active]:!bg-[var(--c-ink)] dark:data-[state=active]:!text-white";

export const backendCheckboxClass =
  "size-5 shrink-0 cursor-pointer rounded-[5px] border border-[var(--c-border-strong)] bg-[var(--c-card)] text-white shadow-none transition-colors outline-none focus-visible:ring-2 focus-visible:ring-[var(--c-accent)] focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 data-[state=checked]:border-[var(--c-ink)] data-[state=checked]:bg-[var(--c-ink)]";
